import styles from './Footer.module.css'

const Socials = {
  Instagram: {
    url: 'https://www.instagram.com/piotr__opala',
    active: true,
  },
  Facebook: {
    url: 'https://www.facebook.com/profile.php?id=61568566993143',
    active: true,
  },
  Bandcamp: {
    url: 'https://piotropala.bandcamp.com/album/somnium',
    active: true,
  },
  YouTube: {
    url: 'https://www.youtube.com/@PiotrOpalaMusic',
    active: false,
  },
  TikTok: {
    url: 'https://www.tiktok.com/@piotropala',
    active: false,
  },
}

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.socials}>
        {Object.entries(Socials).map(
          ([social, data]) =>
            data.active && (
              <a
                key={social}
                href={data.url}
                target='_blank'
                rel='noopener noreferrer'
              >
                {social}
              </a>
            )
        )}
      </div>
    </footer>
  )
}
export default Footer
